import { Bic } from './bic';

export class Bank {
  private _name: string;
  private _bic: Bic;

  constructor(name: string, bic: string) {
    this._name = name;
    this._bic = new Bic(bic);
  }

  /**
   * The name of the bank
   */
  public get name() {
    return this._name;
  }

  /**
   * The BIC of the bank
   */
  public get bic() {
    return this._bic;
  }
}
